/**
 * 历史 localStorage key `hmCareOrderConfirmedSchedule` 已废弃。
 * 保留 clear 以便 Unassign / Assign 失败时清掉用户机器上的残留。
 */
const LEGACY_CONFIRMED_SCHEDULE_KEY = 'hmCareOrderConfirmedSchedule'

function removeLegacyConfirmedScheduleStorage(): void {
  try {
    localStorage.removeItem(LEGACY_CONFIRMED_SCHEDULE_KEY)
    sessionStorage.removeItem(LEGACY_CONFIRMED_SCHEDULE_KEY)
  } catch {
    /* ignore */
  }
}

/** 清理已废弃的 Assign 确认排期缓存 */
export function clearPersistedScheduleForOrder(_orderId?: string): void {
  removeLegacyConfirmedScheduleStorage()
}

/** @deprecated 使用 {@link clearPersistedScheduleForOrder} */
export function clearConfirmedOrderSchedule(orderId?: string): void {
  clearPersistedScheduleForOrder(orderId)
}

// 模块加载时清掉残留，避免旧数据继续影响展示
removeLegacyConfirmedScheduleStorage()
